import { Validator } from 'vee-validate'
import NameInput from './name'
import EntryInput from './entry'
import UnitNo from './unitNo'
import MaskDecimal from './maskDecimal'
import MaskMinValue from './maskMinValue'
import MaskMaxValue from './maskMaxValue'
import FromToDate from './fromToDate'
import StartEndDate from './startEndDate'
import Nric from './nric'
import CreditCardExp from './creditCardExp'
import BdayRange from './bdayRange'
import DaysBeforeCover from './daysBeforeCover'
import StartBeforeToday from './startBeforeToday'
import StartBeforeDate from './startBeforeDate'
import ParamInput from './param'

export default function install() {
  Validator.extend('name', NameInput)
  Validator.extend('entry', EntryInput)
  Validator.extend('unit_no', UnitNo)
  Validator.extend('mask_decimal', MaskDecimal)
  Validator.extend('mask_min_value', MaskMinValue)
  Validator.extend('mask_max_value', MaskMaxValue)
  Validator.extend('from_to_date', FromToDate)
  Validator.extend('start_enddate', StartEndDate)
  Validator.extend('nric', Nric)
  Validator.extend('credit_card_exp', CreditCardExp)
  Validator.extend('bday_range', BdayRange)
  Validator.extend('days_before_cover', DaysBeforeCover)
  Validator.extend('start_before_today', StartBeforeToday)
  Validator.extend('start_before_date', StartBeforeDate)
  Validator.extend('param', ParamInput)
}
